import { Component, Input, OnInit } from "@angular/core";
import {
  NgbModal,
  NgbActiveModal,
  NgbDateStruct,
  NgbCalendar,
} from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { Employee } from "src/app/parametrage/core/model/employee/employee";
import { UserProfile } from "src/app/parametrage/core/model/user-profile";
import { EmployeeService } from "src/app/parametrage/core/service/employee.service";
import { UserProfileService } from "src/app/parametrage/core/service/user-profile.service";
import { TaskService } from "src/app/mon-portefeuille/core/service/task.service";
import { AssignerTaskAvecDelai } from "src/app/core/services/business/model/assigner-task-avec-delai";

@Component({
  selector: "app-assigner-dossier",
  templateUrl: "./assigner-dossier.component.html",
  styleUrls: ["./assigner-dossier.component.scss"],
})
export class AssignerDossierComponent implements OnInit {
  dateEcheance: any;
  time: any;

  @Input() taskId;

  userProfiles: UserProfile[];
  employees: Employee[];

  form2: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  command: AssignerTaskAvecDelai = new AssignerTaskAvecDelai();

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _userProfileService: UserProfileService,
    private _employeeService: EmployeeService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private _taskService: TaskService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      roleAffected: [null, Validators.compose([Validators.required])],
      userAffected: [null, Validators.compose([Validators.required])],
      dueDate: ["", [Validators.compose([Validators.required])]],
      dueHour: ["", [Validators.compose([Validators.required])]],
    });
  }

  ngOnInit() {
    this.getUserProfiles();
  }

  getUserProfiles() {
    this._userProfileService.getUserProfiles().subscribe(
      (data) => {
        this.userProfiles = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getUsers() {
    const roleId = this.form2.value.roleAffected;
    this._employeeService.getEmployeeByProfile(roleId).subscribe(
      (data) => {
        this.employees = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    let month;
    month = this.dateEcheance.month;
    if (this.dateEcheance.month < 10) {
      month = "0" + this.dateEcheance.month;
    }

    let day;
    day = this.dateEcheance.day;
    if (this.dateEcheance.day < 10) {
      day = "0" + this.dateEcheance.day;
    }

    let hour;
    hour = this.time.hour;
    if (this.time.hour < 10) {
      hour = "0" + this.time.hour;
    }

    let minute;
    minute = this.time.minute;
    if (this.time.minute < 10) {
      minute = "0" + this.time.minute;
    }

    this.command.causeAssignation = "UTILISATEUR";
    this.command.dueDate =
      this.dateEcheance.year +
      "-" +
      month +
      "-" +
      day +
      "T" +
      hour +
      ":" +
      minute;
    this.command.username = this.form2.value.userAffected;
    this.command.taskId = this.taskId;

    this.spinner.show();
    this._taskService
      .assigner(this.command)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
